<template>
  <div class="product">
    <img :src="product.product.images.edges[0]?.node.image" :alt="product.product.name">
    <p class="product__name">{{ product.product.name }}</p>
    <p class="product__code">{{ t('profile.orders.code') }} {{ product.attributes.code }}</p>
    <p class="product__price">€{{ product.product.price }}</p>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";

const props = defineProps({
  product: Object
})

const {t} = useI18n()
</script>

<style lang="scss" scoped>
.product {
  padding: 5px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  & img {
    border-radius: 7px;
    width: 65px;
    height: 80px;
    object-fit: cover;
  }

  &__name {
    color: #2F2F2F;
    font-size: 14px;
    font-weight: 700;
    line-height: 25.6px;
  }

  &__code {
    color: #555;
    font-size: 14px;
    font-weight: 400;
    line-height: 25.6px;
  }

  &__price {
    color: #2F2F2F;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    line-height: 25.6px;
  }
}
</style>